<div class="bg-white my-5" style="font-family: Montserrat;">
    <div class="flex gap-3 items-center my-4 mx-4">
      <img (click)="backClicked()" class="rounded-full w-6 h-6 bg-blue-500 cursor-pointer" src="assets/back-icon.svg">
        <p  class="font-semibold text-xl">Authentication</p>
        <h4 class="text-gray-600">|</h4>
        <div class="slideToggle px-2 py-1 bg-blue-100 rounded-lg relative cursor-pointer flex items-center justify-center gap-2" style="border: 1px solid #386AF6;" [class.checked]="isChecked" (click)="toggle()">
            <span style="font-size: 12px;">{{ isChecked ? 'Active' : 'Inactive' }}</span>
            <div [style.backgroundColor]="isChecked ? '#386AF6' : '#CCCCCC'" style="width: 28px; height: 14px; border-radius: 14px;">
              <div class="auth-slider"></div>
        </div>
    </div>
</div>
<div class="bg-white mx-4" [style.display]="isChecked ? 'block' : 'none'">
    <div
    class="flex flex-col gap-3 rounded-2xl"
      style="
        border: 1px solid #ECECEC;
        padding: 10px 20px;
        width: 98%;
      "
    >
      <div class="font-semibold mx-3" style="font-size: 16px;">Authentication URL</div>
      <div class=" flex justify-center mx-3 gap-5" style="width: fit-content;">
        <input
        class="font-normal"
          style="
            border-bottom: 1px solid #ECECEC;
            font-size: 14px;
            width: 382px;
          "
          placeholder="https://webhook.site/1c4f7356-51c4-44ce-87e"
        />
        <br />
      </div>
        <div class="my-4 mb-3 mx-3">
          <button
          class="bg-blue-600 text-white font-medium rounded-2xl"
          style="
            padding: 5px 50px;
            width: fit-content;
            font-size: 14px;
          "
        >
          Confirm
        </button>
        </div>
    </div>
  </div>
  